import React from "react";
import previewPdf from "../../../assets/BCLEbook.pdf";

const PdfPreviewModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[9999] bg-white flex flex-col">

      {/* Header */}
      <div className="flex justify-between items-center px-6 py-4 border-b">
        <h2 className="font-semibold text-lg">
          E-book Preview
        </h2>

        <button
          onClick={onClose}
          className="text-xl font-semibold hover:opacity-70 transition"
        >
          ✕
        </button>
      </div>

      {/* PDF Viewer */}
      <iframe
        src={previewPdf}
        title="PDF Preview"
        className="flex-1 w-full"
      />

      {/* Footer */}
      <div className="px-6 py-4 border-t flex justify-end">
        <a
          href={previewPdf}
          download
          className="bg-[#54B0AF] hover:bg-teal-600 text-white px-6 py-2 rounded-xl transition"
        >
          Download PDF
        </a>
      </div>

    </div>
  );
};

export default PdfPreviewModal;